import React, { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getErrorMessageFromError } from "../../components/ErrorMessage";
import { useApp } from "../../hooks/useApp";
import { ClientDto } from "../../model/ClientDto";
import { ClientDelete, ClientListRequest, ClientSaveRequest, ClientUpdatedRequest } from "../../services/client/ClientService";
import { useSidebarData } from "../global/SidebarDataContext";
import { getMessageTemplateRequest
} from "../../services/templates/MessageTemplatesService";
import { TemplateDto } from "../../model/TemplatesDto";

const ClientsDataContext = createContext();

const ClientsDataContextProvider = ({ children }) => {
    const [listClients, setListClients] = useState([]);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [clientIdToDelete, setClientIdToDelete] = useState('');
    const [formData, setFormData] = useState({});
    const [company, setCompany] = useState(' ');
    const [countryPhone, setCountryPhone] = useState(null);
    const [searchInput, setSearchInput] = useState('');
    const [isFirstRenderRowsPerPage, setIsFirstRenderRowsPerPage] = useState(true);
    const [page, setPage] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [clientActive, setClientActive] = useState(true);
    const [templatesTwilio, setTemplatesTwilio] = useState([]);
    const [templatesEmail, setTemplatesEmail] = useState([]);

    const {
        setSuccessMsg,
        setErrorMsg,
        setLoading,
        loading,
        messageUser,
        authenticate,
        authInfo
    } = useApp();

    const {notificationsWS} = useSidebarData();
    const navigate = useNavigate();

    const handleChangePage = (event, newPage) => {
        setPage(newPage);        
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
    };

    const loadClientsTimeout = () => {
        setTimeout(
            () => loadClients(), 
            100
        );
    };

    useEffect(() => {
        if(authenticate && authInfo) {
            loadClientsTimeout();
        }
    },[page, authenticate, authInfo]);

    useEffect(() => {
        if(isFirstRenderRowsPerPage)
            setIsFirstRenderRowsPerPage(false);
        else{
            if(page == 0)
                loadClientsTimeout();
            else
                setPage(0);
        }
    },[rowsPerPage]);

    const handleCancel = async () => {
        navigate(-1);
        setCountryPhone(null);
    };

    const loadClients = async () => {
        try {
            setLoading(true);
            const statusClient =  (authInfo?.userRole?.id === 1  ? (clientActive ? 'ACTIVE' : 'DELETED') : 'ACTIVE');
            let responseClientsList = await ClientListRequest(0, page, rowsPerPage, company,authInfo.id, authInfo.userRole.id,statusClient,countryPhone ? countryPhone.id : 0,searchInput);
            setTotalItems(responseClientsList.totalElements);
            const clients = responseClientsList.content.map(clientData => {
                return new ClientDto(
                    clientData.id,
                    clientData.name,
                    clientData.cellPhone,
                    clientData.email,
                    clientData.prospect,
                    clientData.jobTitle,
                    clientData.company,
                    clientData.company_name,
                    clientData.status,
                    clientData.countryPhone,
                    clientData.lastContactDate,
                    clientData.lastContactChannel,
                    clientData.customerStatusId,
                    clientData.customerStatusName,
                    clientData.leadTagName,
                    clientData.leadTagId,
                    clientData.enableAiAssistant,
                    clientData.leadTags || [],
                    clientData.leadTagIds || [],
                    clientData.meetingDate,
                    clientData.proposalDate,
                    clientData.notes,
                    clientData.value,
                    clientData.userId,
                    clientData.ownerName
                );
            });
            setListClients(clients);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            const errorMessage = getErrorMessageFromError(error);
            setErrorMsg(errorMessage)
            setLoading(false);
        }
    };

    const onClickMarkChatUnread = (params) => {
        if (messageUser.some(item => item.client.id === params.row.id)) {
            navigate('/dashboard/whatsapp', { state: params.row });
        }
    };

    const openDeleteConfirmation = (clientId) => {
        setClientIdToDelete(clientId);
        setShowDeleteConfirmation(true);
    };

    const closeDeleteConfirmation = () => {
        setClientIdToDelete(null);
        setShowDeleteConfirmation(false);
    };

    const handleDeleteConfirmed = async () => {
        closeDeleteConfirmation();
        if (clientIdToDelete) {
            await handleDelete(clientIdToDelete);
        }
    };

    const handleFormSubmit = async (values) => {
        if(!countryPhone || !countryPhone.id || countryPhone.id == 0){
            setErrorMsg("País es un campo requerido.");
            return; 
        }
        values.countryPhone = countryPhone;
        try {
            const input = {
                ...values
            };
            setLoading(true);
            if (values.id) {
                await ClientUpdatedRequest(input);
                setSuccessMsg("Editado con éxito");
            } else {
                await ClientSaveRequest(input);
                setSuccessMsg("Creado con éxito");
            }           

            setLoading(false);
            if(page == 0)
                loadClientsTimeout();
            else
                setPage(0);
            handleCancel();
        } catch (error) {
            console.error(error);
            let errorMessage = getErrorMessageFromError(error);
            if (!errorMessage) {
                errorMessage = "Error desconocido al procesar la solicitud";
            }
            setErrorMsg(errorMessage);
            setLoading(false);
        }
    };

    const convertToVendor = async (clientId) => {
        try {
            setLoading(true);
            await ClientUpdatedRequest({ id: clientId, prospect: 2 });
            setSuccessMsg("Convertido a Proveedor con éxito");
            if (page == 0) loadClientsTimeout(); else setPage(0);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            const errorMessage = getErrorMessageFromError(error);
            setErrorMsg(errorMessage);
        }
    };

    const handleDelete = async (clientId) => {
        try {
            setLoading(true)
            await ClientDelete(clientId);
            setSuccessMsg("Eliminado con éxito")
            
            if(page == 0)
                loadClientsTimeout();
            else
                setPage(0);
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    };

    //Notifications WebSocket
    useEffect(() => {
        if(notificationsWS?.messageIncoming && notificationsWS?.client?.id) {
            // Ordenar la lista de clientes cuando haya cambios en notificationsWS
            const sortedClients = listClients.slice().sort((a, b) => {
                const aHasNewMessage = notificationsWS.client.id === a.id;
                const bHasNewMessage = notificationsWS.client.id === b.id;

                // Si a tiene mensaje nuevo y b no, a debe aparecer antes en la lista
                if (aHasNewMessage && !bHasNewMessage) return -1;
                // Si b tiene mensaje nuevo y a no, b debe aparecer antes en la lista
                if (!aHasNewMessage && bHasNewMessage) return 1;
                // Si ambos tienen o no tienen mensaje nuevo, no se cambia el orden
                return 0;
            });
            setListClients(sortedClients);
        }
    }, [notificationsWS]);
    
    const handleChangeClientActive = (event) => {
        setClientActive(event.target.checked);
    };

    const loadTemplates = async () => {
        try {
            const whatsappTwilio = {
                type: 'WHATSAPP_TWILIO',
                active: true,
                page: 0,
                size: 100,
                authorized: true                
            }
            const responseDataTwilio = await getMessageTemplateRequest(whatsappTwilio);
            const templateInstancesTwilio = responseDataTwilio.content.map(
                (templateData) => {
                    return new TemplateDto(
                        templateData.id,
                        templateData.template,
                        templateData.name,
                        templateData.type,
                        templateData.active,
                        templateData.authorized,
                        templateData.contentSidTwilio, 
                        templateData.nameTemplateTwilio
                    );
                }
            );
            
            setTemplatesTwilio(templateInstancesTwilio);

            const emailParams = { type: 'EMAIL', active: true, page: 0, size: 100 };
            const responseEmail = await getMessageTemplateRequest(emailParams);
            setTemplatesEmail(
                (responseEmail.content || []).map((t) => ({
                    id: t.id,
                    name: t.name,
                    subject: t.subject || '',
                    template: t.template,
                }))
            );
        } catch (error) { }
    };

    useEffect(() => {
        if(page == 0 && authInfo?.userRole?.id != undefined)
            setTimeout(
                () => loadClients(), 
                100
            );
        else
            setPage(0);
    }, [clientActive]);
    
    //Load init
    useEffect(() => {
        loadTemplates();
    }, []);

    return (
        <ClientsDataContext.Provider value={{
            loading,
            listClients,
            isEditing,
            formData,
            loadClients,
            setIsEditing,
            showDeleteConfirmation,
            clientIdToDelete,
            onClickMarkChatUnread,
            openDeleteConfirmation,
            closeDeleteConfirmation,
            handleDeleteConfirmed,
            handleDelete,
            handleFormSubmit,
            handleCancel,
            setFormData,
            company,
            setCompany,
            countryPhone, 
            setCountryPhone,
            searchInput,
            setSearchInput,
            setSuccessMsg,
            setErrorMsg,
            page, 
            setPage,
            rowsPerPage, 
            setRowsPerPage,
            handleChangePage,
            handleChangeRowsPerPage,
            totalItems, 
            setTotalItems,
            authenticate,
            authInfo,
            handleChangeClientActive,
            clientActive,
            templatesTwilio,
            templatesEmail,
            convertToVendor,
        }}>
            {children}
        </ClientsDataContext.Provider>
    );
};

export { ClientsDataContext, ClientsDataContextProvider };
